export default __webpack_public_path__ + "static/media/zoom-out.0275ff27.png";